import { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "./FoodProductsSection.css";

export default function FoodProductsSection({ localizacao }) {
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(true);
  const containerRef = useRef(null);
  const navigate = useNavigate();

  const SCROLL_STEP = 500;

  // Carrega produtos
  useEffect(() => {
    async function carregarProdutos() {
      try {
        const resCod = await fetch(
          "https://app.eliandroalimentos.com.br/api/produtos_destaque/listar-produtos-ofertasdodia"
        );
        const codData = await resCod.json();

        const codFiltrados = codData
          .filter((item) => item.localizacao === localizacao)
          .map((item) => item.coditem);

        if (!codFiltrados.length) {
          setProdutos([]);
          return;
        }

        const resProdutos = await fetch(
          "https://app.eliandroalimentos.com.br/api/busca/buscar-por-coditem",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ coditems: codFiltrados }),
          }
        );

        const produtosData = await resProdutos.json();

        const produtosComImagem = await Promise.all(
          produtosData.map(async (produto) => {
            try {
              const resImg = await fetch(
                "https://app.eliandroalimentos.com.br/api/produtos/retornaimagemproduto",
                {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ coditem: produto.CodItem }),
                }
              );
              const imgData = await resImg.json();
              return {
                ...produto,
                imagem: imgData?.imagem
                  ? `data:image/bmp;base64,${imgData.imagem}`
                  : null,
              };
            } catch {
              return { ...produto, imagem: null };
            }
          })
        );

        setProdutos(produtosComImagem);
      } catch (err) {
        console.error("Erro ao carregar produtos:", err);
      } finally {
        setLoading(false);
      }
    }

    carregarProdutos();
  }, [localizacao]);

  const produtosVisiveis = useMemo(() => produtos, [produtos]);

  const scrollLeft = () => {
    containerRef.current?.scrollBy({
      left: -SCROLL_STEP,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    containerRef.current?.scrollBy({
      left: SCROLL_STEP,
      behavior: "smooth",
    });
  };

  if (loading) {
    return <p className="FoodProductsSection-status">Carregando produtos...</p>;
  }

if (!produtosVisiveis.length) {
  // Não faz nada, apenas ignora a renderização
  return null;
}


  return (
    <section className="FoodProductsSection-wrapper">
      <button
        className="FoodProductsSection-scroll-btn left"
        onClick={scrollLeft}
      >
        &#8249;
      </button>

      <div className="FoodProductsSection-container">
        <div className="FoodProductsSection-products" ref={containerRef}>
          {produtosVisiveis.map((produto) => (
            <div
              className="FoodProductsSection-product-card"
              key={produto.CodItem}
              onClick={() => navigate(`/cardproduto/${produto.CodItem}`)}
            >
              {produto.imagem ? (
                <img src={produto.imagem} alt={produto.Descricao} />
              ) : (
                <div className="FoodProductsSection-img-placeholder" />
              )}
              <h3>{produto.Descricao}</h3>
              <span>
                {produto.pesob} Kg – Cód. {produto.CodItem}
              </span>
              <button>Ver Produto</button>
            </div>
          ))}
        </div>
      </div>

      <button
        className="FoodProductsSection-scroll-btn right"
        onClick={scrollRight}
      >
        &#8250;
      </button>
    </section>
  );
}
